import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { useAtomValue } from 'jotai';
import { useMemo, type ReactNode } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { themeModeAtom } from '../atoms/themeAtoms';
import { createAppTheme } from '../theme';

interface AppThemeProviderProps {
  children: ReactNode;
}

export function AppThemeProvider({ children }: AppThemeProviderProps) {
  const mode = useAtomValue(themeModeAtom);

  // Recreate the theme object only when mode changes
  const theme = useMemo(() => createAppTheme(mode), [mode]);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}
